import { render, staticRenderFns } from "./3_2_recruitDetail.vue?vue&type=template&id=3181731d&scoped=true&"
import script from "./3_2_recruitDetail.vue?vue&type=script&lang=js&"
export * from "./3_2_recruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./3_2_recruitDetail.vue?vue&type=style&index=0&id=3181731d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181731d",
  null
  
)

export default component.exports